import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { change, untouch, reset } from 'redux-form';
import { callAPI } from './apiActions';
import BigNumber from 'bignumber.js';
import { getFormValuesForSubmittingOrder } from '../../helpers/placeOrderHelper';
import { buyValue, sellValue, orderTypes } from '../../constants/sendOrder/orderEntryFormConstants';
import { MODAL_TYPES, openModal } from './modalActions';
import { orderFormTypes } from '../../constants/sendOrder/orderFormTypes';
import { syncQuantityWithPrice, syncPriceWithQuantity } from '../../helpers/orderHelper';
import { selectedInstrumentSelector } from '../selectors/instrumentPositionSelectors';
import { accountIdSelector } from '../selectors/marginSelectors';
import { convertIncrementToIntDecimalPlaces } from '../../helpers/decimalPlaces/decimalPlacesHelper';
import { truncateToDecimals } from '../../helpers/numberFormatter';
import { level2SellSelector, level2BuySelector } from '../selectors/level2Selectors';
export var placeOrderWithChecks = function placeOrderWithChecks(orderFormType, form) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState, apexCore, level1, instrument, limitPrice, marketPrice;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), apexCore = _getState.apexCore;
              level1 = apexCore.level1, instrument = apexCore.instrument;
              if (!(form.orderType === orderTypes.limit.displayName && form.side === sellValue)) {
                _context.next = 7;
                break;
              }
              limitPrice = new BigNumber(form.limitPrice);
              marketPrice = new BigNumber(level1[instrument.selectedInstrumentId.toString()].BestOffer);
              if (!limitPrice.lt(marketPrice)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt('return', dispatch(openModal(MODAL_TYPES.SUBMIT_LIMIT_ORDER, {
                orderFormType: orderFormType
              })));
            case 7:
              return _context.abrupt('return', dispatch(placeOrder(orderFormType, form)));
            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var placeOrder = function placeOrder(orderFormType, form) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    useNewForm = _ref2.useNewForm;
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var state, selectedAccountId, _getState2, userInfo, _getState2$apexCore, product, level1, level2, selectedInstrument, priceDecimalPlaces, quantityDecimalPlaces, options, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              selectedAccountId = accountIdSelector(state);
              _getState2 = getState(), userInfo = _getState2.user.userInfo, _getState2$apexCore = _getState2.apexCore, product = _getState2$apexCore.product, level1 = _getState2$apexCore.level1, level2 = _getState2$apexCore.level2;
              selectedInstrument = selectedInstrumentSelector(getState());
              priceDecimalPlaces = convertIncrementToIntDecimalPlaces(selectedInstrument.PriceIncrement);
              quantityDecimalPlaces = convertIncrementToIntDecimalPlaces(selectedInstrument.QuantityIncrement);
              options = getFormValuesForSubmittingOrder(orderFormType, {
                state: getState(),
                decimalPlaces: product.decimalPlaces,
                instrument: {
                  selectedInstrumentId: selectedInstrument.InstrumentId
                },
                form: form,
                userInfo: userInfo,
                selectedAccountId: selectedAccountId,
                priceDecimalPlaces: priceDecimalPlaces,
                quantityDecimalPlaces: quantityDecimalPlaces,
                level1: level1,
                level2: level2,
                useNewForm: useNewForm
              });
              response = void 0;
              if (!(orderFormType === orderFormTypes.block)) {
                _context2.next = 14;
                break;
              }
              _context2.next = 11;
              return dispatch(callAPI('SubmitBlockTrade', options));
            case 11:
              response = _context2.sent;
              _context2.next = 17;
              break;
            case 14:
              _context2.next = 16;
              return dispatch(callAPI('SendOrder', options));
            case 16:
              response = _context2.sent;
            case 17:
              return _context2.abrupt('return', response);
            case 18:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var buyPriceClicked = function buyPriceClicked(e) {
  return function (dispatch, getState) {
    e.persist();
    var price = e.currentTarget.dataset.price;
    var state = getState();
    var selectedOrderType = state.form.orderEntry.values.orderType;
    var isStopOrder = selectedOrderType === orderTypes.stopMarket.displayName;
    var _selectedInstrumentSe = selectedInstrumentSelector(state),
      PriceIncrement = _selectedInstrumentSe.PriceIncrement;
    var convertedPriceIncrement = convertIncrementToIntDecimalPlaces(PriceIncrement);
    if (!isStopOrder) {
      dispatch(checkAndSwitchToLimitOrderType());
    }
    dispatch(change('orderEntry', 'side', sellValue));
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    dispatch(change('orderEntry', isStopOrder ? 'stopPrice' : 'limitPrice', truncateToDecimals(parseFloat(price), convertedPriceIncrement)));
  };
};
export var buyQuantityClicked = function buyQuantityClicked(e) {
  return function (dispatch, getState) {
    e.persist();
    var _e$currentTarget$data = e.currentTarget.dataset,
      quantity = _e$currentTarget$data.quantity,
      index = _e$currentTarget$data.index;
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    var state = getState();
    var buy = level2BuySelector(state, {
      filterMode: 'selectedInstrumentId'
    });
    var _selectedInstrumentSe2 = selectedInstrumentSelector(state),
      QuantityIncrement = _selectedInstrumentSe2.QuantityIncrement;
    var convertedQuantityIncrement = convertIncrementToIntDecimalPlaces(QuantityIncrement);
    var overallQuantity = calculateQuantity(truncateToDecimals(quantity, convertedQuantityIncrement), buy, index);
    dispatch(change('orderEntry', 'quantity', overallQuantity));
    dispatch(change('orderEntry', 'side', sellValue));
    dispatch(change('orderEntry', 'orderType', orderTypes.market.displayName));
  };
};
export var sellPriceClicked = function sellPriceClicked(e) {
  return function (dispatch, getState) {
    e.persist();
    var price = e.currentTarget.dataset.price;
    var state = getState();
    var selectedOrderType = state.form.orderEntry.values.orderType;
    var isStopOrder = selectedOrderType === orderTypes.stopMarket.displayName;
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    if (!isStopOrder) {
      dispatch(checkAndSwitchToLimitOrderType());
    }
    var _selectedInstrumentSe3 = selectedInstrumentSelector(state),
      PriceIncrement = _selectedInstrumentSe3.PriceIncrement;
    var convertedPriceIncrement = convertIncrementToIntDecimalPlaces(PriceIncrement);
    dispatch(change('orderEntry', isStopOrder ? 'stopPrice' : 'limitPrice', truncateToDecimals(parseFloat(price), convertedPriceIncrement)));
    dispatch(change('orderEntry', 'side', buyValue));
  };
};
export var sellQuantityClicked = function sellQuantityClicked(e) {
  return function (dispatch, getState) {
    e.persist();
    var _e$currentTarget$data2 = e.currentTarget.dataset,
      quantity = _e$currentTarget$data2.quantity,
      index = _e$currentTarget$data2.index;
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    var state = getState();
    var sell = level2SellSelector(state, {
      filterMode: 'selectedInstrumentId'
    });
    var _selectedInstrumentSe4 = selectedInstrumentSelector(state),
      QuantityIncrement = _selectedInstrumentSe4.QuantityIncrement;
    var convertedQuantityIncrement = convertIncrementToIntDecimalPlaces(QuantityIncrement);
    var overallQuantity = calculateQuantity(truncateToDecimals(quantity, convertedQuantityIncrement), sell, index, false);
    dispatch(change('orderEntry', 'quantity', overallQuantity));
    dispatch(change('orderEntry', 'side', buyValue));
    dispatch(change('orderEntry', 'orderType', orderTypes.market.displayName));
  };
};
export var clearOrderForm = function clearOrderForm(formName) {
  return function (dispatch) {
    dispatch(clearFeeAndTotalAmountValues(formName));
    dispatch(reset(formName));
  };
};
export var clearBuySellForm = function clearBuySellForm() {
  return function (dispatch) {
    var form = 'buySell';
    dispatch(clearField(form, 'quantity', ''));
    dispatch(clearField(form, 'price', ''));
    dispatch(clearField(form, 'amountRadio', 'custom'));
    dispatch(clearField(form, 'limitPrice', ''));
    dispatch(clearField(form, 'fee', '0'));
    dispatch(clearField(form, 'responseMessage', ''));
  };
};
export var showBuySellSuccessMessage = function showBuySellSuccessMessage() {
  return function (dispatch) {
    // context.t('Your order was filled successfully!')
    dispatch(change('buySell', 'responseMessage', 'Your order was filled successfully!'));
  };
};
export var showBuySellFailMessage = function showBuySellFailMessage() {
  return function (dispatch) {
    // context.t('Your order failed, please try again')
    dispatch(change('buySell', 'responseMessage', 'Your order failed, please try again'));
  };
};
export var synchronizeQuantityWithPrice = function synchronizeQuantityWithPrice(price, form, field, formObj) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
      _getState3$apexCore = _getState3.apexCore,
      level2 = _getState3$apexCore.level2,
      decimalPlaces = _getState3$apexCore.product.decimalPlaces;
    var selectedInstrument = selectedInstrumentSelector(getState());
    var quantity = syncQuantityWithPrice(price, {
      level2: level2,
      selectedInstrument: selectedInstrument,
      side: formObj.values.side,
      decimalPlaces: decimalPlaces
    });
    dispatch(change(form, field, quantity));
  };
};
export var synchronizePriceWithQuantity = function synchronizePriceWithQuantity(quantity, form, field, formObj) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
      _getState4$apexCore = _getState4.apexCore,
      level2 = _getState4$apexCore.level2,
      decimalPlaces = _getState4$apexCore.product.decimalPlaces;
    var selectedInstrument = selectedInstrumentSelector(getState());
    var price = syncPriceWithQuantity(quantity, {
      level2: level2,
      selectedInstrument: selectedInstrument,
      side: formObj.values.side,
      decimalPlaces: decimalPlaces
    });
    dispatch(change(form, field, price));
  };
};
var calculateQuantity = function calculateQuantity(initValue, orders, quantityIndex) {
  var buy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var init = new BigNumber(initValue);
  var quantity = orders.filter(function (data, index) {
    return buy ? index < quantityIndex : index > quantityIndex;
  }).reduce(function (prev, current) {
    return prev.plus(current.Quantity);
  }, init);
  return quantity.toString();
};

/**
 * Switch order type to 'Limit' if 'Market' is selected before
 */
var checkAndSwitchToLimitOrderType = function checkAndSwitchToLimitOrderType() {
  return function (dispatch, getState) {
    var selectedOrderType = getState().form.orderEntry.values.orderType;
    if (selectedOrderType === orderTypes.market.displayName) {
      dispatch(change('orderEntry', 'orderType', orderTypes.limit.displayName));
    }
  };
};
var clearFeeAndTotalAmountValues = function clearFeeAndTotalAmountValues(form) {
  return function (dispatch) {
    dispatch(clearField(form, 'fee', '0'));
    dispatch(clearField(form, 'totalAmount', '0'));
  };
};
var clearField = function clearField(form, field, initialValue) {
  return function (dispatch) {
    dispatch(change(form, field, initialValue));
    dispatch(untouch(form, field));
  };
};